const StatusbarConstants = {
    SET_STATE_ACTION: 'SET_STATE_ACTION',
    ALL_MISSING: 'ALL_MISSING',
    DIMENSIONS_MISSING: 'DIMENSIONS_MISSING',
    TYRE_INDEX_AND_POSTCODE_MISSING: 'TYRE_INDEX_AND_POSTCODE_MISSING',
    TYRE_INDEX_MISSING: 'TYRE_INDEX_MISSING',
    SPEED_INDEX_MISSING: 'SPEED_INDEX_MISSING',
    LOAD_INDEX_MISSING: 'LOAD_INDEX_MISSING',
    POSTCODE_MISSING: 'POSTCODE_MISSING',
    NONE_MISSING: 'NONE_MISSING'
};

export default StatusbarConstants;